export const PR_AGENCY_META_DESCRIPTION_BG =
  "Perceptica помага на PR агенциите да докажат резултатите от PR пред клиентите чрез мултиклиентски мониторинг, конкурентен анализ и подкрепа при питчове.";
